import { adjust, assoc } from 'ramda';

export const DEFAULT_COLUMN_WIDTH = 100;
export const MIN_COLUMN_WIDTH = 60;

export const defaultProjectColumns = [
    {
        name: 'details',
        width: 53,
        noResize: true,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'number',
        width: 35,
        noResize: true
    }
];

export const defaultProjectMassColumns = [
    {
        name: 'details',
        width: 53,
        noResize: true,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'number',
        width: 35,
        noResize: true
    }
];

export const defaultWorksheetColumns = [
    {
        name: 'checkbox',
        width: 60,
        noResize: true,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'number',
        width: 35,
        noResize: true
    }
];

export const defaultWorksheetMassColumns = [
    {
        name: 'checkbox',
        width: 60,
        noResize: true,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'number',
        width: 60,
        noResize: true,
    },
];

export const defaultApprovalColumns = [
    {
        name: 'checkbox',
        width: 60
    },
    {
        name: 'general',
        keyName: 'position',
        width: 'auto'
    },
    {
        name: 'sender',
        width: '25%'
    },
    {
        name: 'date',
        width: 180
    }
];

export const defaultApprovalPersonColumns = adjust(2, assoc('keyName', 'senderName'), defaultApprovalColumns);
export const defaultApprovalProjectColumns = defaultApprovalColumns;

export const defaultRequestColumns = [
    {
        name: 'checkbox',
        width: 60
    },
    {
        name: 'position',
        width: 'auto'
    },
    {
        name: 'quantity',
        width: 80,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'responsibleName',
        width: '25%'
    },
    {
        name: 'date',
        width: 180
    }
];

export const legalRequestColumns = [
    {
        name: 'checkbox',
        width: 60
    },
    {
        name: 'position',
        width: 'auto'
    },
    {
        name: 'quantity',
        width: 80,
        additionalClass: 'table-cell-center'
    },
    {
        name: 'responsibleName',
        width: '25%'
    },
    {
        name: 'date',
        width: 180
    }
];
